"use client";
import { useLocale } from 'next-intl';
import { Button } from '../ui/button';

export default function LanguageSwitcher() {
  const locale = useLocale();

  const switchLocale = (newLocale: string) => {
    if (typeof window !== 'undefined') {
      // Establecer la cookie - el cliente HTTP manejará el header automáticamente
      document.cookie = `NEXT_LOCALE=${newLocale};path=/`;
      
      window.location.reload();
    }
  };

  return (
    <div className="flex gap-2">
      <Button
        variant={locale === 'es' ? 'default' : 'outline'}
        onClick={() => switchLocale('es')}
      >
        ES 🇲🇽
      </Button>
      <Button
        variant={locale === 'en' ? 'default' : 'outline'}
        onClick={() => switchLocale('en')}
      >
        EN 🇺🇸
      </Button>
    </div>
  );
}